import system_bar_bottom from './system-bar-bottom.svg';
import system_bar_left from './system-bar-left.svg';
import system_bar_right from './system-bar-right.svg';
import system_bar_top from './system-bar-top.svg';
import system_boards from './system-boards.svg';
import system_camera from './system-camera.svg';
import system_code from './system-code.svg';
import system_cylinder from './system-cylinder.svg';
import system_data from './system-data.svg';
import system_desktop from './system-desktop.svg';
import system_desktop_tower from './system-desktop-tower.svg';
import system_devices from './system-devices.svg';
import system_keyboard from './system-keyboard.svg';
import system_laptop from './system-laptop.svg';
import system_mobile from './system-mobile.svg';
import system_mobile_button from './system-mobile-button.svg';
import system_monitor from './system-monitor.svg';
import system_monitor_play from './system-monitor-play.svg';
import system_mouse from './system-mouse.svg';
import system_moving_desk from './system-moving-desk.svg';
import system_printer from './system-printer.svg';
import system_qr_code from './system-qr-code.svg';
import system_save from './system-save.svg';
import system_tablet from './system-tablet.svg';
import system_tablet_button from './system-tablet-button.svg';
import system_terminal from './system-terminal.svg';
import system_wifi_high from './system-wifi-high.svg';
import system_wifi_low from './system-wifi-low.svg';
import system_wifi_medium from './system-wifi-medium.svg';
import system_wifi_none from './system-wifi-none.svg';
import system_wifi_off from './system-wifi-off.svg';
import system_wifi_problem from './system-wifi-problem.svg';
import system_window from './system-window.svg';
import system_window_check from './system-window-check.svg';
import system_window_close from './system-window-close.svg';
import system_window_code_block from './system-window-code-block.svg';
import system_window_sidebar from './system-window-sidebar.svg';
import system_window_terminal from './system-window-terminal.svg';

export const V2_SYSTEM_ICONS: { [char: string]: string } = {
  system_bar_bottom,
  system_bar_left,
  system_bar_right,
  system_bar_top,
  system_boards,
  system_camera,
  system_code,
  system_cylinder,
  system_data,
  system_desktop,
  system_desktop_tower,
  system_devices,
  system_keyboard,
  system_laptop,
  system_mobile,
  system_mobile_button,
  system_monitor,
  system_monitor_play,
  system_mouse,
  system_moving_desk,
  system_printer,
  system_qr_code,
  system_save,
  system_tablet,
  system_tablet_button,
  system_terminal,
  system_wifi_high,
  system_wifi_low,
  system_wifi_medium,
  system_wifi_none,
  system_wifi_off,
  system_wifi_problem,
  system_window,
  system_window_check,
  system_window_close,
  system_window_code_block,
  system_window_sidebar,
  system_window_terminal,
};

export const V2_SYSTEM_ICON_NAMES: string[] = Object.keys(V2_SYSTEM_ICONS);
